import { constants } from "../../../constants";

export default class CloseHelp {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.closeHelp();
    }

    exposeEvent() {
        let event = {};
        switch (this.gb.walletProtocol) {
            case constants.POKERSTARS:
                event["xc2rgCloseHelp"] = this._default;
                break;
            default:
                event["closeHelp"] = this._default
        }

        return event;
    }
}
